export default "__VITE_ASSET__cf2ec330__"